import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import ContractConsent from '../contractConsent/Model.ContractConsent';
import contractConsentAuditListApi from './list/Api.ContractConsentAudit.List';

export default class ContractConsentAudit
  extends Model<Model.IContractConsentAudit>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractConsentAudit>
{
  id: number;
  requestContractConsentId: number;
  contractConsentId?: number;
  contractConsent?: Model.IContractConsent;
  responseStatusCode: string;
  requestBody: string;
  responseBody: string;
  userId?: number;
  user?: Model.IUser;
  userOverrideId?: number;
  timestamp?: string;
  acceptLanguage: string;
  host: string;
  ip: string;
  isAuthenticated: boolean;
  method: string;
  path: string;
  protocol: string;
  queryString: string;
  referer: string;
  scheme: string;
  traceId: string;
  userAgent: string;
  userEmail: string;
  headers?: Record<string, string>;

  constructor(
    data: Partial<Model.IContractConsentAudit> | Utils.FormData<Model.IContractConsentAudit>,
    language?: Locale.Languages
  ) {
    super(
      {
        user: User,
        contractConsent: ContractConsent,
      },
      language
    );
    this.update(data);
  }

  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: `${this?.requestContractConsentId}` || this.id.toString(),
    };
  }

  toContractConsentAuditInfo() {
    return {
      id: this.id,
      requestContractConsentId: this.requestContractConsentId,
      contractConsentId: this.contractConsentId,
      responseStatusCode: this.responseStatusCode,
      requestBody: ContractConsentAudit.formatAuditJson(this.requestBody),
      responseBody: ContractConsentAudit.formatAuditJson(this.responseBody),
      userId: this.userId,
      userOverrideId: this.userOverrideId,
      timestamp: this.timestamp,
      acceptLanguage: this.acceptLanguage,
      host: this.host,
      ip: this.ip,
      isAuthenticated: this.isAuthenticated,
      method: this.method,
      path: this.path,
      protocol: this.protocol,
      queryString: this.queryString,
      referer: this.referer,
      scheme: this.scheme,
      traceId: this.traceId,
      userAgent: this.userAgent,
      userEmail: this.userEmail,
      headers: ContractConsentAudit.formatAuditJson(this.headers),
    };
  }

  static formatAuditJson(value: unknown) {
    if (value === null || value === undefined) return value;

    if (typeof value === 'string') {
      const trimmedValue = value.trim();
      if (!trimmedValue) return value;

      try {
        return JSON.stringify(JSON.parse(trimmedValue), null, 2);
      } catch {
        return value;
      }
    }

    if (typeof value === 'object') {
      try {
        return JSON.stringify(value, null, 2);
      } catch {
        return String(value);
      }
    }

    return value;
  }

  static async list(body?: Api.Core.ContractConsentAudit.List.IRequest) {
    const { payload, ...rest } = await contractConsentAuditListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractConsentAudit(it)),
        count: payload.count,
      },
    };
  }
}
